<div class="ziro-admin-page-content">
  <div data-automation="device-utilization-content" class="col-md-10 offset-md-1 ziro-report-content">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div
          [innerHtml]="
            (isAdmin
              ? 'tkey;reports.device_utilization.description'
              : 'tkey;reports.device_utilization.description.site_based'
            ) | escapeHtml: { nextRefreshed: getRefresh(nextRunTime), lastRefreshed: getRefresh(lastRunTime) }
          "
        ></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (isRefreshing) {
      <div class="card border-primary text-center mb-3" data-automation="utilization-refreshing-card">
        <div class="card-body strong">
          <i class="{{ ziroIcons.SAVING }} pe-1"></i>
          <span>{{ 'tkey;reports.device_utilization.refresh.in_progress' | translate }}</span>
        </div>
      </div>
    }

    <ziro-loading-block [hidden]="!isSearching || isRefreshing"></ziro-loading-block>

    @if (!isSearching && !isRefreshing && data.length === 0 && !showCustomAlert) {
      <div class="mt-1 ziro-page-alert alert border-warning" data-automation="device-utilization-no-cdrs-warning">
        <i [ngClass]="ziroIcons.WARNING_TRIANGLE" class="text-warning fa-4x"></i>
        <div class="ms-3" [innerHTML]="'tkey;reports.device_utilization.no_cdr.message' | escapeHtml"></div>
      </div>
    }

    @if (!isSearching && !isRefreshing && (data.length > 0 || !!showCustomAlert)) {
      <ziro-datatable
        [isCondensed]="true"
        [columns]="columns"
        [rowDataSource]="data"
        [uniqueRowIdentifier]="'deviceName'"
        [stickyColumnCount]="1"
        [mainFilterPlaceholder]="'tkey;reports.device_utilization.search_placeholder' | translate"
        [dataAutomation]="tableDataAutomation"
        [noResultsAlertClass]="'table-danger'"
        [showCustomAlert]="showCustomAlert"
        [class]="'ziro-card'"
      >
        <ziro-datatable-switch-filter
          [label]="'tkey;menu.report.show_new_devices'"
          [matchFn]="isNewDeviceMatch"
          [dataAutomation]="'device-utilization-new-device-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-switch-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.device_utilization.model.header'"
          [items]="deviceModelOptions"
          [matchFn]="isDeviceModelMatch"
          [dataAutomation]="'device-utilization-model-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.device_utilization.pool.header'"
          [items]="devicePoolOptions"
          [matchFn]="isDevicePoolMatch"
          [dataAutomation]="'device-utilization-device-pool-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.device_utilization.registration_status.header'"
          [items]="registrationStatusOptions"
          [matchFn]="isRegistrationStatusMatch"
          [dataAutomation]="'device-utilization-registration-status-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-slider-filter
          [label]="'tkey;reports.device_utilization.last_registered.header'"
          [matchFn]="isLastRegisteredMatch"
          [toggleLabel]="'tkey;reports.device_utilization.last_registered.toggle_label'"
          [sliderLabel]="'tkey;reports.device_utilization.last_registered.slider_label'"
          [floorValue]="0"
          [floorValueLabel]="'tkey;time.today'"
          [ceilValue]="callRetentionDays || 0"
          [dataAutomation]="'device-utilization-last-registered-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-slider-filter>
        <ziro-datatable-slider-filter
          [label]="'tkey;reports.device_utilization.last_used.header'"
          [matchFn]="isLastUsedMatch"
          [toggleLabel]="'tkey;reports.device_utilization.last_used.toggle_label'"
          [sliderLabel]="'tkey;reports.device_utilization.last_used.slider_label'"
          [floorValue]="0"
          [floorValueLabel]="'tkey;time.today'"
          [ceilValue]="callRetentionDays || 0"
          [dataAutomation]="'device-utilization-last-used-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-slider-filter>
        <div class="text-center" alert-content>
          {{ 'tkey;reports.device_utilization.job_status.error.table_message_pre' | translate }}
          <button
            data-automation="custom-alert-button"
            class="btn btn-border btn-link strong"
            (click)="onRefreshClicked()"
          >
            {{ 'tkey;reports.device_utilization.job_status.error.table_message_clickable' | translate }}
          </button>
          {{ 'tkey;reports.device_utilization.job_status.error.table_message_post' | translate }}
        </div>
      </ziro-datatable>
    }
  </div>
</div>

<ziro-bottom-nav data-automation="device-utilization-bottom-nav"></ziro-bottom-nav>
